var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAavgoPortal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Aavgo_Portal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aavgo_Portal",
    "data-name": "Aavgo Portal",
    clipPath: "url(#clip-Aavgo_Portal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "billboard_17069098_1_",
    "data-name": "billboard_17069098(1)",
    transform: "translate(4.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M68.588,0H20.923C17.219,0,11.1,0,11.1,9.823V67.472c0,8.213,6.119,9.823,9.823,9.823H35.094V90.177H32.356a5.017,5.017,0,0,0-4.992,4.992V98.39a1.614,1.614,0,0,0,1.61,1.61h31.4a1.614,1.614,0,0,0,1.61-1.61V95.169a5.017,5.017,0,0,0-4.992-4.992H54.417V77.295H68.588c8.535,0,9.823-4.187,9.823-9.823V9.823C78.25,6.119,78.25,0,68.588,0ZM58.765,95.008v1.61H30.746v-1.61a1.787,1.787,0,0,1,1.771-1.771H57.155A1.655,1.655,0,0,1,58.765,95.008ZM71.809,67.472a3.3,3.3,0,0,1-3.382,3.382h-47.5a3.4,3.4,0,0,1-3.382-3.382V9.823a3.3,3.3,0,0,1,3.382-3.382h47.5a3.3,3.3,0,0,1,3.382,3.382Z",
    transform: "translate(0)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M62.289,6H19.776A2.544,2.544,0,0,0,17.2,8.576V61.234a2.544,2.544,0,0,0,2.576,2.576H62.289a2.544,2.544,0,0,0,2.576-2.576V8.576A2.544,2.544,0,0,0,62.289,6Zm-.644,54.75H20.26V9.221H61.644V60.75Z",
    transform: "translate(3.723 3.662)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M23.51,23.921H52.818a1.732,1.732,0,0,0,1.61-1.61v-9.5a1.614,1.614,0,0,0-1.61-1.61H23.51a1.614,1.614,0,0,0-1.61,1.61v9.5A1.732,1.732,0,0,0,23.51,23.921Z",
    transform: "translate(6.591 6.835)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M39.394,35.8H29.41a1.61,1.61,0,0,0,0,3.221h9.984a1.61,1.61,0,1,0,0-3.221Z",
    transform: "translate(10.192 21.849)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAavgoPortal);
export default __webpack_public_path__ + "static/media/aavgo-portal.d6977d57e8701881b41046ca24d53dbb.svg";
export { ForwardRef as ReactComponent };